import "../../../styles/login.scss";

import Icon, {iconTypes} from "./Icon.jsx";

import {Localization} from "../util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "./ResponsiveColumn.jsx";
import ResponsiveRows from "./ResponsiveRows.jsx";
import TextField from "./TextField.jsx";

import bg from "../../../assets/images/bg.png";
import logo from "../../../assets/images/engrospartner_logo.png";
import {withRouter} from "react-router-dom";

class ForgotPasswordPage extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = {
            id: "",
        };

        this.onChange = this.onChange.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.validateId = this.validateId.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.setCurrentLanguage("no");
    }

    onChange(change) {
        this.setState(change);
    }

    resetPassword(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.resetPassword(this.props.history, this.state.id);
    }

    onClickCancel(event) {
        event.stopPropagation();
        event.preventDefault();
        this.props.history.replace("/dashboard");
    }

    validateId(str) {
        const {
            validateEmail,
            validateCusNo,
        } = this.props;
        return validateCusNo(str) || validateEmail(str);
    }

    render(){
        const {
            loggingIn,
            localization,
        } = this.props;

        const canSubmit = !loggingIn && this.validateId(this.state.id);

        return (
            <React.Fragment>
                <div className="login-background">
                    <img src={bg} className="login-background-img"/>
                </div>
                <div className="login-engrospartner-logo">
                    <img src={logo} />
                </div>
                <div className="login-wrapper card-default">
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12}>
                            <div className="reset-header-wrapper">
                                <Icon type={iconTypes.circleQuestion} className="header-icon"/>
                                <div className="header-text">
                                    {localization.text("login","enterCustomerNumberAndEmail")}
                                </div>
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                    <div className="hr"/>
                    <form disabled={!canSubmit} onSubmit={this.resetPassword}>
                        <ResponsiveRows>
                            <ResponsiveColumn xs={12}>
                                <TextField onEdit={this.onChange} onChange={this.onChange} iconType={iconTypes.account} source={this.state} property={"id"} validation={this.validateId} autoComplete="new-password" placeholder={localization.text("login","customerid")} disabled={false}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <div className={"login-reset-pass-button-spacer"}>
                                    <button className={"btn primary block"} disabled={!canSubmit}>
                                        {localization.text("login","resetPassword")}
                                    </button>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <button className={"btn block"} onClick={this.onClickCancel}>
                                    {localization.text("login","back")}
                                </button>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </form>
                </div>
                <div className="login-copyright-notice" >
                    Kolly Tool 2019 @ All rights reserved.
                </div>
            </React.Fragment>
        );
    }
}

ForgotPasswordPage.propTypes = {
    localization: Localization.propTypes.isRequired,
    setCurrentLanguage: PropTypes.func.isRequired,
    loggingIn: PropTypes.bool.isRequired,
    resetPassword: PropTypes.func.isRequired,
    validateEmail: PropTypes.func.isRequired,
    validateCusNo: PropTypes.func.isRequired,
    history: PropTypes.object,
};

export default withRouter(ForgotPasswordPage);